import { apolloClient } from '@client/api/graphql/client';
import { useInfiniteQuery } from '@tanstack/react-query';
import {
  CommunityPostsArgs,
  GetCommunityDocument,
  GetCommunityQuery,
  GetCommunityQueryVariables,
} from '../../../../generated/graphql';
import _ from 'lodash';
import { communityQueryKeys } from '../constants';

export const getParams = ({
  lastId = undefined,
  direction = undefined,
}: CommunityPostsArgs) => {
  if (lastId && direction) {
    return { lastId, direction };
  }
  return {};
};

const getPosts = async (communityId: number, pageParam: CommunityPostsArgs) => {
  const response = await apolloClient.query<
    GetCommunityQuery,
    GetCommunityQueryVariables
  >({
    query: GetCommunityDocument,
    variables: {
      id: communityId,
      ...getParams(pageParam),
    },
    fetchPolicy: 'network-only',
  });
  return response.data.community?.posts;
};

export const useCommunityPosts = (communityId: number) => {
  return useInfiniteQuery({
    queryKey: communityQueryKeys.posts(Number(communityId)),
    queryFn: async ({ pageParam = {} }) => {
      return await getPosts(communityId, pageParam);
    },
    getNextPageParam: (lastPage) => {
      const lastCommunityPost = _.last(lastPage);
      if (lastCommunityPost?.id) {
        return {
          lastId: lastCommunityPost.id,
          direction: 'olderThan',
        };
      }
    },
    keepPreviousData: true,
    refetchOnMount: true,
    enabled: typeof communityId !== null,
    refetchOnWindowFocus: false,
    refetchInterval: 30000,
  });
};
